import React from 'react';
import './clientesGrid.css';


function ClientesGrid({ arrayClientes, clickDelete, clickRenovar, clickEdit }) {

    const formatarData = (dataIsoString) => {
        if (!dataIsoString) return '-';
        try {
            const data = new Date(dataIsoString);
            data.setUTCHours(12, 0, 0, 0);
            return data.toLocaleDateString('pt-BR');
        } catch (error) {
            return '-';
        }
    };

    const formatarLocalidade = (cidade, uf) => {
        if (!cidade && !uf) return '-';
        return `${cidade || ''} - ${uf || ''}`;
    };

    const decodificarStatus = (statusNumero) => {
        switch (statusNumero) {
            case 1: return 'Ativo';
            case 2: return 'Pendente';
            case 3: return 'Vencido';
            case 4: return 'Inativo';
            default: return 'Descon.';
        }
    };

    const getStatusBadgeClass = (statusNumero) => {
        switch (statusNumero) {
            case 1: return 'success';
            case 2: return 'warning';
            case 3: return 'danger';
            case 4: return 'secondary';
            default: return 'dark';
        }
    };

    if (!arrayClientes || arrayClientes.length === 0) {
        return (
            <div className="empty-state text-center p-5">
                <div className="empty-icon mb-3" style={{ fontSize: '3rem', color: '#dee2e6' }}>
                    <i className="fas fa-users"></i>
                </div>
                <h5 className="empty-title text-muted">Nenhum cliente encontrado</h5>
                <p className="text-muted small">
                    Não há clientes cadastrados ou que correspondam aos critérios da sua pesquisa.
                </p>
            </div>
        );
    }

    return (
        <div className="marcas-grid-container">
            <table className="table-custom">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '120px' }}>Ações</th>
                        <th className="text-start">Nome / Razão Social</th>
                        <th className="text-center" style={{ width: '100px' }}>Status</th>
                        <th className="text-center" style={{ width: '110px' }}>Cadastro</th>
                        <th className="text-center" style={{ width: '110px' }}>Vencimento</th>
                        <th className="text-start">E-mail</th>
                        <th className="text-start">Telefone</th>
                        <th className="text-start">Localidade</th>
                        <th className="text-center">Usuários</th>
                        <th className="text-center">Sessões Ativas</th>
                        <th className="text-center">Licenças</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayClientes.map((cliente) => {
                        const statusTexto = decodificarStatus(cliente.status);
                        return (
                            <tr key={cliente.id}>
                                <td className="text-center">
                                    <div className="actions-cell">
                                        <button onClick={() => clickEdit(cliente.id)} className="btn-action-sm btn-edit" title="Editar">
                                            <i className="fas fa-edit"></i>
                                        </button>
                                        <button onClick={() => clickRenovar(cliente.id)} className="btn-action-sm btn-success" title="Renovar Assinatura" style={{ color: '#198754' }}>
                                            <i className="fas fa-calendar-check"></i>
                                        </button>
                                        <button onClick={() => clickDelete(cliente.id)} className="btn-action-sm btn-delete" title="Excluir">
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>{cliente.nome}</td>
                                <td className="text-center">
                                    <span className={`badge bg-${getStatusBadgeClass(cliente.status)} bg-opacity-10 text-${getStatusBadgeClass(cliente.status)} border border-${getStatusBadgeClass(cliente.status)} rounded-pill`} style={{ fontSize: '0.7rem' }}>
                                        {statusTexto}
                                    </span>
                                </td>
                                <td className="text-center">{formatarData(cliente.data_cadastro)}</td>
                                <td className="text-center">{formatarData(cliente.data_vencimento)}</td>
                                <td>{cliente.email}</td>
                                <td>{cliente.telefone}</td>
                                <td>{formatarLocalidade(cliente.cidade, cliente.uf)}</td>
                                <td className="text-center">{cliente.qt_usuarios}</td>
                                <td className="text-center">{cliente.qt_sessoes_ativas}</td>
                                <td className="text-center">{cliente.max_sessions || 3}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default ClientesGrid;